(function(){
  var FORM_NAME='paleta-testerow';

  // ---- FAQ accordion ----
  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=q.closest('.faq-item');
      var was=item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function(el){el.classList.remove('open')});
      if(!was)item.classList.add('open');
    });
  });

  // ---- Floating helper card (after 8s, dismissible per session) ----
  var floater=document.getElementById('helpFloater');
  if(floater){
    var dismissed=false;
    try{dismissed=sessionStorage.getItem('ngt_floater_dismissed')==='1'}catch(e){}
    if(!dismissed){
      setTimeout(function(){floater.classList.add('show')},8000);
      var fc=floater.querySelector('.floater-close');
      if(fc)fc.addEventListener('click',function(){
        floater.classList.remove('show');
        try{sessionStorage.setItem('ngt_floater_dismissed','1')}catch(e){}
      });
    }
  }

  // ---- Prefill "interesuje mnie" select when clicking a product CTA ----
  document.querySelectorAll('[data-tester]').forEach(function(el){
    el.addEventListener('click',function(){
      var val=el.getAttribute('data-tester');
      document.querySelectorAll('select[name="contact[Interesujacy tester]"]').forEach(function(sel){
        for(var i=0;i<sel.options.length;i++){
          if(sel.options[i].value===val){sel.selectedIndex=i;break}
        }
      });
    });
  });

  // ---- Phone input: keep digits and spaces only ----
  document.querySelectorAll('input[name="contact[phone]"]').forEach(function(inp){
    inp.addEventListener('input',function(){
      var v=inp.value.replace(/[^0-9+ ]/g,'');
      if(v!==inp.value)inp.value=v;
    });
  });

  // ================= ATRYBUCJA źRÓDŁA =================
  // Zapamiętujemy UTM-y z pierwszego wejścia w sesji, żeby doradca wiedział,
  // skąd przyszedł lead (kampania FB, Google, mailing itd.).
  function attribution(){
    var keys=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'];
    var q=new URLSearchParams(window.location.search);
    var found={};
    keys.forEach(function(k){ if(q.get(k))found[k]=q.get(k) });
    try{
      if(Object.keys(found).length){
        found._ref=document.referrer||'(direct)';
        found._landing=window.location.pathname;
        sessionStorage.setItem('ngt_attr',JSON.stringify(found));
      }else{
        var saved=sessionStorage.getItem('ngt_attr');
        if(saved)found=JSON.parse(saved);
      }
    }catch(e){}
    if(!found._ref)found._ref=document.referrer||'(direct)';
    return found;
  }
  var ATTR=attribution();

  // ---- Build a technical e-mail + readable message body before submit ----
  // Shopify's contact form needs an e-mail address to deliver the notification.
  // The lead only gives name + phone, so we derive a technical address from the
  // phone number and put every real detail in the message body.
  document.querySelectorAll('form[action*="/contact"]').forEach(function(f){
    var started=false;
    f.addEventListener('focusin',function(){
      if(started)return; started=true;
      track('lead_form_started',{form_name:FORM_NAME});
    });

    f.addEventListener('submit',function(){
      var g=function(sel){var e=f.querySelector(sel);return e?e.value.trim():''};
      var name=g('input[name="contact[name]"]');
      var phone=g('input[name="contact[phone]"]');
      var area=g('select[name="contact[Interesujacy tester]"]');
      var note=g('input[name="contact[Uwagi]"]');
      var digits=phone.replace(/[^0-9]/g,'');

      var mail=f.querySelector('.lf-email');
      if(mail&&!mail.value){
        mail.value='lead-'+(digits||Date.now())+'@nutragroup.lead';
      }
      var body=f.querySelector('.lf-body');
      if(body){
        var lines=['NOWY LEAD - dobor testerow','Imie: '+name,'Telefon: '+phone];
        if(area)lines.push('Interesuje go/ja: '+area);
        if(note)lines.push('Uwagi: '+note);
        lines.push('Zrodlo: landing "Paleta testerow" (/pages/lp-testery)');
        Object.keys(ATTR).forEach(function(k){ lines.push(k+': '+ATTR[k]) });
        body.value=lines.join('\n');
      }
      track('lead_form_submitted',{form_name:FORM_NAME,tester:area||''});
    });
  });

  // ================= TRACKING =================
  // Wysyłamy zdarzenie do wszystkich możliwych odbiorców naraz:
  // Shopify Web Pixels (Customer events), GTM dataLayer, Meta Pixel, GA4.
  // Każde wywołanie jest w try/catch, więc brak danego narzędzia niczego nie psuje.
  function track(eventName,payload){
    payload=payload||{};
    try{
      if(window.Shopify&&window.Shopify.analytics&&window.Shopify.analytics.publish){
        window.Shopify.analytics.publish(eventName,payload);
      }
    }catch(e){}
    try{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push(Object.assign({event:eventName},payload));
    }catch(e){}
    try{ if(window.gtag)window.gtag('event',eventName,payload); }catch(e){}
  }

  // ---- Konwersja: formularz wysłany poprawnie ----
  // Shopify po wysłaniu przekierowuje na ?contact_posted=true i renderuje .form-ok.
  var ok=document.querySelector('.form-ok');
  if(ok){
    var leadPayload={form_name:FORM_NAME,page:'lp-testery'};
    Object.keys(ATTR).forEach(function(k){ if(k.indexOf('_')!==0)leadPayload[k]=ATTR[k] });
    track('lead_submitted',leadPayload);
    try{ if(window.fbq)window.fbq('track','Lead',{content_name:FORM_NAME}); }catch(e){}
    try{ if(window.gtag)window.gtag('event','generate_lead',{form_name:FORM_NAME}); }catch(e){}
    setTimeout(function(){ok.scrollIntoView({behavior:'smooth',block:'center'})},250);
  }
  var err=document.querySelector('.form-err');
  if(err){setTimeout(function(){err.scrollIntoView({behavior:'smooth',block:'center'})},250)}

  // ---- Głębokość przewijania: sygnał jakości ruchu ----
  var marks=[25,50,75,100],hit={};
  window.addEventListener('scroll',function(){
    var h=document.documentElement.scrollHeight-window.innerHeight;
    if(h<=0)return;
    var pct=Math.round((window.scrollY/h)*100);
    marks.forEach(function(m){
      if(pct>=m&&!hit[m]){hit[m]=true;track('scroll_depth',{percent:m,page:'lp-testery'})}
    });
  },{passive:true});

  // ---- Kliknięcia w numer telefonu ----
  document.querySelectorAll('a[href^="tel:"]').forEach(function(a){
    a.addEventListener('click',function(){track('phone_click',{page:'lp-testery'})});
  });

  // ---- Animated counters ----
  function animateCount(el){
    var to=parseFloat(el.getAttribute('data-count-to'));
    var suffix=el.getAttribute('data-count-suffix')||'';
    var dur=900,start=null;
    function step(ts){
      if(!start)start=ts;
      var p=Math.min(1,(ts-start)/dur);
      el.textContent=Math.floor(p*to)+suffix;
      if(p<1)requestAnimationFrame(step);else el.textContent=to+suffix;
    }
    requestAnimationFrame(step);
  }

  // ---- Scroll reveal ----
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('in');
          if(entry.target.hasAttribute('data-count-to'))animateCount(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },{threshold:.15});
    document.querySelectorAll('.anim,[data-count-to]').forEach(function(el){obs.observe(el)});
  }else{
    document.querySelectorAll('.anim').forEach(function(el){el.classList.add('in')});
    document.querySelectorAll('[data-count-to]').forEach(animateCount);
  }
})();
